module.exports = __webpack_public_path__ + "static/media/president.56af0d90.png";